import { Icon } from '@/common/components/Icon'
import { Modal } from '@/components/ui/modal'
import { FC } from 'react'

const Loader: FC = () => {
  return (
    <Modal
      open
      onOpenChange={() => {}}
      size="sm"
      contentClassName="border-none bg-transparent shadow-none [&>button]:hidden"
      tabIndex={-1}
      title={<span className="sr-only">Loading</span>}
      onOpenAutoFocus={(event) => event.preventDefault()}
      onCloseAutoFocus={(event) => event.preventDefault()}
    >
      <div className="flex flex-col items-center gap-4">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-monochrome-120 animate-spin">
          <Icon
            icon="loading"
            width="40"
            height="40"
            viewBox="0 0 40 40"
            className="text-white"
          />
        </div>
        <p className="text-sm text-monochrome-1">Loading, please wait ...</p>
      </div>
    </Modal>
  )
}

export default Loader
